import { render, staticRenderFns } from "./superwordSideband.vue?vue&type=template&id=360e875a&scoped=true"
import script from "./superwordSideband.vue?vue&type=script&lang=js"
export * from "./superwordSideband.vue?vue&type=script&lang=js"
import style0 from "./superwordSideband.vue?vue&type=style&index=0&id=360e875a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360e875a",
  null
  
)

export default component.exports